import { render, staticRenderFns } from "./TermsAndConditionsModal.vue?vue&type=template&id=00f83145&scoped=true&"
import script from "./TermsAndConditionsModal.vue?vue&type=script&lang=js&"
export * from "./TermsAndConditionsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00f83145",
  null
  
)

export default component.exports